import { message, Modal, notification } from "antd";
import { ENTERED_FROM_LOGIN } from "constants/auth";
import { useEffect, useState } from "react";
import useLogout from "./useLogout";

const useQuery = ({
  queryFn,
  onSuccess,
  onError,
  args = [],
  autoFetch = true
}) => {
  const { logout } = useLogout();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(autoFetch ? true : false);
  const enteredFromLogin = localStorage.getItem(ENTERED_FROM_LOGIN) === 'true';

  const refetch = async (...args) => {
    setLoading(true)
    try {
      const data = await queryFn(...args)

      if (data.message === "invalid or expired jwt") {

        if (enteredFromLogin) {
          message.error({
            key: "TOKEN_INVALID",
            content: "La sesión ha expirado",
          });
        }

        logout();
        return;
      }

      if (data.status !== "error") {
        setData(data)
        onSuccess && onSuccess(data)
        return data;
      }

      throw new Error(data.message || "Error de servidor inesperado");
    } catch (error) {
      const isNetworkError = error instanceof TypeError;

      if (isNetworkError) {
        notification.error({
          key: "NETWORK_ERROR",
          message: "El servicio no está disponible en este momento",
          placement: "top",
          duration: 0,
        });
        return;
      }

      const msg = error?.message || "Error inesperado";

      const safeErr = error instanceof Error ? error : new Error(msg);
      safeErr.message = msg;

      setError(safeErr);
      onError?.(safeErr);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!autoFetch) return
    refetch(...args)
  }, [...args])

  return {
    data,
    setData,
    error,
    loading,
    refetch
  }
}

export default useQuery